<template>
  <div class="math-calendar">
    <div class="calendar-header">
      <div class="year-month">{{ currentYearMonth }}</div>
      <div class="calendar-controls">
        <span class="arrow" @click="handlePrevWeek">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="13"
            viewBox="0 0 14 13"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.07122 11.167C8.93848 11.167 8.80522 11.1161 8.70411 11.015L4.55907 6.86326C4.35685 6.66103 4.35685 6.33281 4.55959 6.13059L8.70463 1.98555C8.90737 1.78281 9.23507 1.78281 9.43781 1.98555C9.64055 2.18829 9.64055 2.516 9.43781 2.71874L5.65937 6.49718L9.43833 10.2818C9.64055 10.4846 9.64055 10.8128 9.43781 11.0156C9.3367 11.1161 9.20396 11.167 9.07122 11.167Z"
              fill="black"
              fill-opacity="0.9"
            />
          </svg>
        </span>
        <span
          class="today"
          :class="{ disabled: isCurrentWeek }"
          @click="!isCurrentWeek && handleBackToday()"
        >
          回到本周
        </span>
        <span class="arrow" @click="handleNextWeek">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="13"
            viewBox="0 0 14 13"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.92878 11.167C5.06152 11.167 5.19478 11.1161 5.29589 11.015L9.44093 6.86326C9.64315 6.66103 9.64315 6.33281 9.44041 6.13059L5.29537 1.98555C5.09263 1.78281 4.76493 1.78281 4.56219 1.98555C4.35945 2.18829 4.35945 2.516 4.56219 2.71874L8.34063 6.49718L4.56167 10.2818C4.35945 10.4846 4.35945 10.8128 4.56219 11.0156C4.6633 11.1161 4.79604 11.167 4.92878 11.167Z"
              fill="black"
              fill-opacity="0.9"
            />
          </svg>
        </span>
      </div>
    </div>
    <div class="calendar-body">
      <div class="weekday-wraps">
        <div
          v-for="day in displayDays"
          :key="day.date"
          class="dates date-cell"
          :class="{
            today: day.isToday,
            current: day.isCurrent,
            active: day.isActive,
            'has-dots': dotDates.includes(day.postDate),
            'pink-dots': judgeIsPast(day.postDate) > 0,
            'red-dots': judgeIsPast(day.postDate) == 0,
            'gray-dots': judgeIsPast(day.postDate) < 0,
          }"
          @click="clickCalendarHandle(day)"
        >
          <div class="date-cell-date">{{ day.weekday }}</div>
          <div class="date-cell-day">
            {{ day.date }}
          </div>
        </div>
      </div>
      <!-- <div class="dates">
        <div
          v-for="day in displayDays"
          :key="day.date"
          :class="{
            'date-cell': true,
            today: day.isToday,
            current: day.isCurrent,
          }"
        >
          {{ day.date }}
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';

dayjs.locale('zh-cn');
const DATE_FORMAT = 'YYYY-MM-DD';
export default {
  name: 'MathCalendar',
  props: {
    caclDate: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      currentDate: dayjs(),
      selectedDate: this.caclDate ? dayjs(this.caclDate) : dayjs(),
      weekDays: ['五', '六', '日', '一', '二', '三', '四'],
      activeDate: this.caclDate ? dayjs(this.caclDate) : dayjs(), // 新增 activeDate 来跟踪当前激活的日期
      dotDates: [],
    };
  },
  created() {
    this.$emit('dateClick', this.activeDate.format(DATE_FORMAT));
  },
  computed: {
    currentYearMonth() {
      return this.selectedDate.format('YYYY年M月');
    },
    isCurrentWeek() {
      const today = dayjs();
      const startDate = this.getStartDate(today);
      const currentStartDate = this.getStartDate(this.selectedDate);
      return startDate.isSame(currentStartDate, 'day');
    },
    displayDays() {
      const startDate = this.getStartDate(this.selectedDate);
      return Array.from({ length: 7 }, (_, index) => {
        const date = startDate.add(index, 'day');
        return {
          date: date.date(),
          weekday: this.weekDays[index],
          isToday: date.isSame(this.currentDate, 'day'),
          isCurrent: date.isSame(this.selectedDate, 'day'),
          isActive: this.activeDate ? date.isSame(this.activeDate, 'day') : false,
          fullDate: date, // 添加完整日期对象
          postDate: date.format(DATE_FORMAT),
        };
      });
    },
  },
  watch: {
    displayDays: {
      immediate: true,
      async handler(newValue, oldValue) {
        // 判断新旧数组是否完全一致
        const isArrayEqual =
          oldValue &&
          newValue.length === oldValue.length &&
          newValue.every((item, index) => item.postDate === oldValue[index].postDate);
        if (!isArrayEqual) {
          const startDate = newValue[0].postDate;
          const endDate = newValue[newValue.length - 1].postDate;
          //  课程类型，0:全部课程 1:互动课
          const courseType = 1;
          const data = await this.$http.get('/backend-api/app/study/schedule/range', {
            startDate,
            endDate,
            courseType,
          });
          this.dotDates = data;
        }
      },
    },
  },
  methods: {
    judgeIsPast(date) {
      return dayjs().startOf('day').valueOf() - dayjs(date).startOf('day').valueOf();
    },
    clickCalendarHandle(day) {
      this.activeDate = day.fullDate;
      // 可以在这里添加其他需要的逻辑，比如触发事件通知父组件
      // const hasDate = this.dotDates.includes(day.postDate);
      // console.log('-----fullDate:', day.fullDate, day.fullDate.format());

      this.$emit('dateClick', day.fullDate.format(DATE_FORMAT));
      this.$webSeeSendTrack({
        event_id: 'study_week_calendar_select_day',
        event_type: 'click',
        data: {
          date: day.fullDate.format(DATE_FORMAT),
        },
      });
    },

    getStartDate(date) {
      // 获取本周五
      const friday = 5;
      const curr = date.day();
      const diff = curr < friday ? friday - curr : friday + (7 - curr);
      return date.add(diff - 7, 'day').startOf('day');
    },
    getEndDate(date) {
      // 获取下周四
      return this.getStartDate(date).add(6, 'day').endOf('day');
    },
    handlePrevWeek() {
      this.selectedDate = this.selectedDate.subtract(7, 'day');
      const startDate = this.getStartDate(this.selectedDate);
      this.activeDate = startDate;
      this.$emit('dateClick', startDate.format(DATE_FORMAT));
      this.$webSeeSendTrack({
        event_id: 'study_change_week_calendar_range',
        event_type: 'click',
        data: {
          week: 'prev',
        },
      });
    },
    handleNextWeek() {
      this.selectedDate = this.selectedDate.add(7, 'day');
      const startDate = this.getStartDate(this.selectedDate);
      this.activeDate = startDate;
      this.$emit('dateClick', startDate.format(DATE_FORMAT));
      this.$webSeeSendTrack({
        event_id: 'study_change_week_calendar_range',
        event_type: 'click',
        data: {
          week: 'next',
        },
      });
    },
    handleBackToday() {
      this.selectedDate = dayjs();
      this.activeDate = dayjs();
      this.$emit('dateClick', dayjs().format(DATE_FORMAT));
      this.$webSeeSendTrack({
        event_id: 'study_back_to_current_week_day',
        event_type: 'click',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.math-calendar {
  font-family: 'PingFang SC';
  display: flex;
  width: 100%;
  padding: 24px 32px 8px;
  background: #fff;
  border-radius: 8px;
  box-sizing: border-box;
  align-items: center;
  user-select: none;

  .calendar-header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 127px;
    height: 56px;
    padding-bottom: 11px;
    margin-right: 77px;

    .year-month {
      font-size: 14px;
      font-weight: 500;
      color: #1e1c22;
      line-height: 20px;
      margin-bottom: 8px;
    }

    .calendar-controls {
      display: flex;
      align-items: center;
      gap: 4px;

      .arrow {
        cursor: pointer;
        box-sizing: border-box;
        width: 28px;
        text-align: center;
        background-color: #fafafa;
        line-height: 28px;
        border-radius: 6.222px;

        &:hover {
          color: #ff4242;
        }
      }

      .today {
        cursor: pointer;
        font-size: 12px;
        color: #1e1c22;
        width: 63px;
        height: 28px;
        line-height: 28px;
        background-color: #fafafa;
        text-align: center;
        border-radius: 6.222px;

        &:hover {
          color: #ff4242;
        }
        &.disabled {
          color: #ccc;
          cursor: not-allowed;
          &:hover {
            color: #ccc;
          }
        }
      }
    }
  }

  .calendar-body {
    flex: 1;
    .weekday-wraps {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;

      .has-dots {
        &::after {
          content: ' ';
          position: absolute;
          left: 0;
          right: 0;
          bottom: -16px;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          margin: auto;
          // background: red;
        }
      }
      .pink-dots {
        &::after {
          background: #ffcccc;
        }
      }
      .gray-dots {
        &::after {
          background: #c0beca;
        }
      }
      .red-dots {
        &::after {
          background: #ff4242;
        }
      }
      .dates {
        position: relative;
        width: 64px;
        height: 64px;
        border-radius: 8px;
        text-align: center;
        color: #1e1c22;
        cursor: pointer;
        background-color: #fafafa;
        .date-cell-date {
          margin-top: 12.5px;
          line-height: 17px;
          font-size: 12px;
          color: #8c8b97;
        }
        .date-cell-day {
          font-size: 16px;
          font-weight: 500;
          line-height: 22px;
          color: #1e1c22;
        }
        &.active {
          background: #ff2020 !important;
          .date-cell-date,
          .date-cell-day {
            color: #fff !important;
          }
          box-shadow: 0px 2px 12px 0px rgba(255, 66, 66, 0.34);
        }
        &.today {
          background: #ffefef;
          .date-cell-day {
            color: #ff2020;
          }
        }

        &:hover {
          background: rgba(191, 207, 248, 0.7);
        }
        &.active:hover {
          background: #e50000 !important;
        }
        &.today:hover {
          background: #ff2020;
          .date-cell-date,
          .date-cell-day {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
